/** Google Drive / Apps Script HTML error pages (not JSON). */
export function isGoogleAuthHtml(text) {
  const s = String(text || "");
  return (
    s.includes("<!DOCTYPE html>") &&
    (s.includes("accounts.google.com") ||
      s.includes("Sign in") ||
      s.includes("Unauthorized") ||
      s.includes("Authorization is required"))
  );
}

export const APPS_SCRIPT_ACCESS_MESSAGE =
  "Apps Script web app is not public. Open Apps Script → Deploy → Manage deployments → " +
  "edit your Web app → Who has access: Anyone → Save → copy the /exec URL → " +
  "set REACT_APP_ORDER_SUBMIT_URL on Netlify to that URL.";

export function isGoogleDriveHtmlError(text) {
  const s = String(text || "");
  return (
    s.includes("<!DOCTYPE html>") &&
    (s.includes("unable to open the file") ||
      s.includes("Page Not Found") ||
      s.includes("Page not found") ||
      s.includes("docs-drivelogo"))
  );
}

export function appsScriptHtmlErrorMessage() {
  return (
    "Login service is misconfigured (invalid Apps Script URL). " +
    "Redeploy google-apps-script-orders.gs as a web app (Anyone), " +
    "set REACT_APP_ORDER_SUBMIT_URL on Netlify to the /exec URL, and redeploy the site."
  );
}
